module.exports = __webpack_public_path__ + "static/media/2_.727b6b76.png";